<span [ngStyle]="{'width': width, 'height': width, 'borderColor': color, 'borderBottomColor': 'transparent'}" class="loader"></span>